import React, {useContext} from 'react'
import FileStore from './FileStore'
import { UIStore } from './UIStore'

export const createStore = () => new RootStore()

export const StoreContext = React.createContext<RootStore | null>(null)

export const StoreProvider = ({ store, children }: { store: RootStore; children: React.ReactNode }) => {
  return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>
}

export function useStore(): RootStore {
  const store = useContext(StoreContext)
  if (!store) {
    throw new Error('store cannot be null! check your <StoreProvider ...>')
  }
  return store
}
export class RootStore {
  fileStore = new FileStore(this)
  uiStore = new UIStore(this)
}

export { observer } from 'mobx-react-lite'
export { runInAction } from 'mobx'

export type IStores = RootStore
